import styled from '@emotion/styled';
import H3 from '@base/H3/H3';
import { Spacings, mediaQuery, Fonts } from '@styles/index';
import Divider from '@base/Divider/Divider';

const Wrapper = styled.div`
  margin-top: ${Spacings.SPACING_8B};
  ${mediaQuery.uptoMobile} {
    margin-bottom: -${Spacings.SPACING_1B};
  }
`;
const StyledDivider = styled(Divider)`
  width: 32px;
  height: 2px;
  border-radius: ${Spacings.SPACING_22};
  margin: ${Spacings.SPACING_6B} ${Spacings.SPACING_0B};
  ${mediaQuery.uptoMobile} {
    margin: ${Spacings.SPACING_4B} ${Spacings.SPACING_0B};
  }
`;

const Price = styled.div`
  display: flex;
  align-items: flex-end;
`;

const GreyOutPrice = styled(H3)`
  color: var(--color-text-secondary);
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H4};
  }
`;

const GreyOutPriceSection = ({ price }) => {
  if (price === null || price === undefined) return null;

  return (
    <Wrapper>
      <StyledDivider />
      <Price>
        <GreyOutPrice>₹{price} </GreyOutPrice>
      </Price>
    </Wrapper>
  );
};

export default GreyOutPriceSection;
